// src/analytics/utils/visitorStorage.js

const VISITOR_SESSION_KEY = "monappliclub_visitor_session_token";

export function getVisitorSessionToken() {
  return sessionStorage.getItem(VISITOR_SESSION_KEY);
}

export function saveVisitorSessionToken(token) {
  if (!token) return;

  sessionStorage.setItem(VISITOR_SESSION_KEY, token);
}

export function removeVisitorSessionToken() {
  sessionStorage.removeItem(VISITOR_SESSION_KEY);
}